import { css } from '@emotion/css';
import theme from '@efexteam/mui-theme';

const wrapper = css({
  border: `1px solid ${theme.palette.grey[200]}`,
  width: '45%',
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
});

const descriptionContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
});

const buttonContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),

  '& > .MuiButtonBase-root': {
    width: '50%',
  },
});

const statusApprovedContainer = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  backgroundColor: theme.palette.success.light,
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  borderRadius: theme.spacing(1),
  color: theme.palette.success.dark,
});

const statusDeclinedContainer = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  backgroundColor: theme.palette.error.light,
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  borderRadius: theme.spacing(1),
  color: theme.palette.error.dark,
});

const LifeProofStyles = {
  wrapper,
  descriptionContainer,
  buttonContainer,
  statusApprovedContainer,
  statusDeclinedContainer,
};

export default LifeProofStyles;
